var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"clinical-users-filters"},[_c('RoleFilter',{on:{"filtersChanged":_vm.emitFiltersChanged}}),_vm._v(" "),_c('AccountStatusFilter',{attrs:{"hide-no-contact":true},on:{"filtersChanged":_vm.emitFiltersChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }